// Dammit ie its 2015
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn', 'test',
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

angular.module('dybTemplates', []);

// This is the main angular module for the dyb application.
app = angular.module('dyb', [
    'ngAnimate', /* 'ngTouch', */ 'ngMessages', 'ngSanitize',
    'angularMoment', 'ui.router', 'monospaced.elastic', 'ui.select',
    'dyb.util', 'dyb.page', 'dyb.programs', 'dyb.students', 'dybComponents',
    'dybReports', 'dybSettings', 'dybTemplates', 'dybForms', 'dybTags',
    'changeLog', 'LocalStorageModule', 'angulartics',
    'angulartics.google.analytics'])


.constant('angularMomentConfig', {preprocess: 'utc'})


// Work around for dynamic name fields
// See https://github.com/angular/angular.js/issues/1404#issuecomment-41793623
.config(function($provide, $httpProvider, msdElasticConfig, dybVersion, dybIsLocal) {
    msdElasticConfig.append = '\n';

    function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    $httpProvider.interceptors.push(function($injector) {
        return {
            request: function(request) {
              // relative urls are always templates?
              if (request.url[0] !== '/' && !endsWith(request.url, '.html')) {
                  request.url = "/templates/" + request.url + ".html";
                  if (dybIsLocal) {
                    request.url += "?v=" + dybVersion;
                  }
              }

              return request;
            }
        };
    });


    function makeStateful($delegate) {
        $delegate.$stateful = true;
        return $delegate;
    }

    $provide.decorator('includedByStateFilter', makeStateful);
    $provide.decorator('isStateFilter', makeStateful);

    function dynamicName(getName) {

        return /* @ngInject */ function($delegate) {
            var directive = $delegate[0],
            controller = directive.controller;

            // @ngInject
            directive.controller = function($scope, $element, $attrs, $injector) {
                var $interpolate = $injector.get('$interpolate');
                $attrs.$set('name', $interpolate(getName($attrs))($scope));
                $injector.invoke(controller, this, {
                    '$scope': $scope,
                    '$element': $element,
                    '$attrs': $attrs
                });
            };

            return $delegate;
        }
    }

    $provide.decorator('ngModelDirective', dynamicName(function(attrs) {
        return attrs.name || '';
    }));

    $provide.decorator('formDirective', dynamicName(function(attrs) {
        return attrs.name || attrs.ngForm || '';
    }));
})


// Configure the application on first run.
.run(function($rootScope, $state, $stateParams, Page, Principal, dybVersion) {
  $rootScope.version = dybVersion;

  // State and params are available on all states.
  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
  $rootScope.$user = Principal;
  $rootScope.$page = Page;
  $rootScope.ngModelBlur = {
      updateOn: 'default blur',
      debounce: {'default': 500, 'blur': 0}
  }

  $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
      if (toState.defaultChild) {
          event.preventDefault();
          $state.go(toState.defaultChild, toParams);
      }
  });

  $rootScope.countWatchers = function() {
    var q = [$rootScope], watchers = 0, scope;
    while (q.length > 0) {
      scope = q.pop();
      if (scope.$$watchers) {
        watchers += scope.$$watchers.length;
      }
      if (scope.$$childHead) {
        q.push(scope.$$childHead);
      }
      if (scope.$$nextSibling) {
        q.push(scope.$$nextSibling);
      }
    }
    $rootScope.watcher_count = watchers + " watchers";
  };

})

// TrackJS error handling
.config(function ($provide) {

    /* @ngInject */
    function TrackJS($delegate, $window) {
        return function(exception, cause) {
            if ($window.trackJs) {
                  $window.trackJs.track(exception);
            }
            $delegate(exception, cause);
        }
    }

    $provide.decorator("$exceptionHandler", TrackJS);
})

.config(function(localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('dyb')
});


(function() {
  var initInjector = angular.injector(['ng']);
  var $http = initInjector.get('$http');

  $http.get('/api/tag/config').then(
    function (response) {
      angular.module('dybTags').constant('TagTypes', response.data.item);
      angular.element(document).ready(function() {
          angular.bootstrap(document, ['dyb'], {strictDi: true});
        });
    }
  );
})();
